<template>
  <div class="page new-ticket">
    <header>
      <div @click="back" tabindex="0" @keypress.space="back" class="back-btn"><i class="fa fa-fw fa-chevron-left"></i></div>
      <div class="view-title">{{ 'login' | lang }}</div>
    </header>
    <div>
      <div class="small-form">
        <!-- <p>Inserisci le tue credenziali eccetera eccetera</p> -->
        <div class="floating-label">
          <input v-model="email" placeholder=" " type="text" :class="{ invalid: invalidEmail }" @keypress.enter="$refs.pwdref.focus" />
          <label>{{ 'Email' | lang }}</label>
        </div>
        <div class="floating-label">
          <input v-model="password" placeholder=" " :type="showPassword ? 'text' : 'password'" class="with-icon-right" :class="{ invalid: !password }" ref="pwdref" @keypress.enter="$refs.loginref.click" />
          <button class="i right" @click="showPassword = !showPassword"><i class="fa fa-fw right" :class="{ 'fa-eye-slash': showPassword, 'fa-eye': !showPassword }"></i></button>
          <label>Password</label>
        </div>
        <div @click="rememberMe = !rememberMe" class="i-check-container" v-clickspace>
          <i class="fa fa-fw" :class="{ 'fa-check-square-o': rememberMe, 'fa-square-o': !rememberMe }"></i>{{ 'RememberMe' | lang }}
        </div>
        <div>
          <button class="full-width" @click="login" :disabled="!isConnected || invalidForm || isWaiting" ref="loginref">{{ 'login' | lang }}</button>
          <button class="full-width" @click="checkLoginAndGoTo('/register', true)" :disabled="!isConnected">{{ 'register' | lang }}</button>
          <button class="full-width" @click="checkLoginAndGoTo('/passwordrecovery', true)" :disabled="!isConnected">{{ 'IsPwdForgot' | lang }}</button>
        </div>
        <div v-if="!isConnected" class="text-red">{{ 'NoNetwork' | lang }}</div>
        <div v-else-if="status">
          <div v-if="status === 'waiting'">
            <i class="fa fa-fw fa-refresh fa-spin"></i>{{ 'pleaseWait' | lang }}
          </div>
          <div v-else-if="status === 'error'" class="text-red">
            <i class="fa fa-fw fa-exclamation-triangle"></i>{{ (statusDetails || 'errorOccured') | lang }}
          </div>
          <div v-else-if="status === 'success'" class="text-green">
            <i class="fa fa-fw fa-check"></i>{{ 'LoginSuccessful' | lang }}
          </div>
        </div>
      </div>
    </div>
    <!-- <footer>
      
    </footer> -->
  </div>
</template>

<script>
import page from '@/mixins/routeControl'
import UserServices from '@/mixins/services/userServices'

export default {
  name: 'Account',
  mixins: [ page, UserServices ],
  data () {
    return {
      email: '',
      password: '',
      status: '',
      statusDetails: null,
      showPassword: false,
      rememberMe: true
    }
  },
  computed: {
    invalidEmail () {
      return !this.email // return !this.checkEmailValidity(this.email)
    },
    invalidForm () {
      return this.invalidEmail || !this.password
    },
    isWaiting () {
      return this.status === 'waiting'
    }
  },
  methods: {
    login () {
      this.email = this.email.trim()
      this.showPassword = false
      this.status = 'waiting'
      this._doUserLogin(this.email, this.password).then(data => {
        this.user = data
        // this.user.Email = 's.orioli@nomos.biz' // this.email

        this._getUserProfile().then(profilo => {
          this.$set(this.user, 'Email', profilo.Contact.Email)
          if (this.rememberMe) {
            localStorage.setItem('login_credentials', JSON.stringify({ email: this.email, password: this.password }))
            localStorage.setItem('login_email', this.email)
          } else {
            localStorage.removeItem('login_credentials')
            console.warn('removed login_data and login_credentials')
          }
          if (data.NotNotifiedPayments && data.NotNotifiedPayments.length) {
            let toBeVerified = data.NotNotifiedPayments.map(paym => {
              let p = { ...paym, isLocalStorage: false, total: this.paymentsToBeVerified.length + 1, usertoken: data.Token }
              this.store.commit({ type: 'addPaymentToBeVerified', payment: p })
              return p
            })
            this.internalBus.$emit('startNotNotifiedPaymentsManagement', toBeVerified)
          }
          localStorage.setItem('login_data', JSON.stringify({ ...data }))

          this.status = 'success'
          this.userProfile = { profilo }
          this._getUserCSCList().then(csclist => {
            this.userProfile.tessere = csclist
            /* setTimeout(() => {
              this.goTo(this.waitingLoginPage, true, true)
              this.waitingLoginPage = null
            }, 700) */
            if (this.waitingLoginPage) {
              this.goTo(this.waitingLoginPage, true, true)
              this.waitingLoginPage = null
            } else {
              this.goTo('/', true, true)
            }
          })
        }).catch(this.loginError)
      }).catch(this.loginError)
    },
    loginError (response) {
      this.user = null
      this.statusDetails = ''
      this.status = 'error'
      console.log(response)
      if (response.status === 401) {
        this.statusDetails = 'wrongLoginData'
      }
    }
  },
  beforeDestroy () {},
  mounted () {
    let cr = localStorage.getItem('login_credentials')
    if (cr && cr !== 'null') {
      cr = JSON.parse(cr)
      this.email = cr.email
      this.password = cr.password
    } else if (process.env.NODE_ENV === 'development') {
      this.email = 'EXT00000000027'
      this.password = 'Pippo27!'
    }
  },
  watch: {}
}
</script>

<style></style>
